import { render, staticRenderFns } from "./PazienteTeleconsultoEditComponent.vue?vue&type=template&id=7958bf8c"
import script from "./PazienteTeleconsultoEditComponent.vue?vue&type=script&lang=js"
export * from "./PazienteTeleconsultoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports